"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var doveGrayColor = exports.doveGrayColor = '#fff';
var dividerColor = exports.dividerColor = '#c0c1c3';
var whiteColor = exports.whiteColor = '#FFFFFF';
var blueNotification = exports.blueNotification = '#1081a6';
var darkOrange = exports.darkOrange = '#ef6c00';
var offWhite = exports.offWhite = '#fafbfc';
var deepBlue = exports.deepBlue = '#00f';
var black = exports.black = '#000';
var mediumGray = exports.mediumGray = '#999';
var fontColorSecondary = exports.fontColorSecondary = '#600060';
var green = exports.green = '#6db841';
var primaryPurple = exports.primaryPurple = "#600060";